
// create an axios instance
const url_href = window.location.href
let baseURL = ''
let url_name = ''
// const baseURL = 'http://fy.cdjkyl.com'

// const url_name = 'wj'
if (url_href.indexOf('80') !== -1) {
  // baseURL = 'http://192.168.0.13:7970'// 开发

  // baseURL = 'http://47.99.77.190:7970',
  // baseURL = 'http://47.99.77.190:7970',
  // baseURL = 'http://192.168.182.97:7970/',
  // baseURL = 'http://192.168.110.98:7970', // 开发
  baseURL = 'https://plapi.cdjkyl.com',
  url_name = 'wj'
} else if (url_href.indexOf('dev') !== -1) { // 望江
  // baseURL = 'http://47.99.77.190:7970',
  baseURL = 'http://fy.cdjkyl.com',
  url_name = 'wj'
} else {
  baseURL = 'https://plapi.cdjkyl.com',
  url_name = 'wj'
}
const service = {
  baseURL,
  url_name
}

export default service
